import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
import { getDataQuicksBookLogAsync, setPageSize, setSortConfig, setIsRemoveFilterSetting } from '../../accountQBOnline/accountQBLog/QuicksBookLogSlice';
import OffCanvas from "../../../../common/OffCanvas"
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../../common/Pagination";
import moment from "moment";
import QuickBooksLogFilter from "./QuickBooksLogFilter";
import QuickBookLogItem from "./QuickBooksLogItem";
import Loader from '../../../../common/Loader';
import PageSizeSelect from "../../../../common/PageSizeSelect";

const QuickBookLog = () => {
    const { t } = useTranslation();
    const generalObject = {
        "name": t('Filters'),
        "width": "500px",
        "componentName": <QuickBooksLogFilter t={t} />
    }
    const { quikBookLogList, isReload, selectedRecord, isLoading, currentPage, pageSize, totalItems, start, recordsFiltered, direction, columnIndex, search, startDate, endDate, optionActionStatusValue, optionQBEventValue } = useAppSelector((state) => state.quicksBookLog);
    const { pageId, menuList, IsEdit, sessionAccountEmployeeId, maxMenuHeight } = useAppSelector((state) => state.globalState);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (isReload) {
            // let SearchParamsValues = { page: currentPage, pageSize: pageSize, start: start, Order: columnIndex, OrderDir: direction, search: " ", StartDate: `${moment(startDate).format('YYYY-MM-DD')}`, EndDate: `${moment(endDate).format('YYYY-MM-DD')}`, ActionStatus: optionActionStatusValue, QBEvent: optionQBEventValue };
            let SearchParamsValues = { page: currentPage, pageSize: pageSize, start: start, Order: columnIndex, OrderDir: direction, search: " ", StartDate: startDate, EndDate: endDate, ActionStatus: optionActionStatusValue, QBEvent: optionQBEventValue };
            dispatch(getDataQuicksBookLogAsync(SearchParamsValues));
        }
    }, [isReload]);

    useEffect(() => {
        // let SearchParamsValues = { page: currentPage, pageSize: pageSize, start: start, Order: columnIndex, OrderDir: direction, search: " ", StartDate: `${moment(startDate).format('YYYY-MM-DD')}`, EndDate: `${moment(endDate).format('YYYY-MM-DD')}`, ActionStatus: optionActionStatusValue, QBEvent: optionQBEventValue };
        let SearchParamsValues = { page: currentPage, pageSize: pageSize, start: start, Order: columnIndex, OrderDir: direction, search: " ", StartDate: startDate, EndDate: endDate, ActionStatus: optionActionStatusValue, QBEvent: optionQBEventValue };
        dispatch(getDataQuicksBookLogAsync(SearchParamsValues))
            .unwrap()
            .then((originalPromiseResult) => {
                dispatch(setIsRemoveFilterSetting(false));

            })
            .catch((rejectedValueOrSerializedError) => {
            })

    }, [dispatch]);

    const handlePageSizeChange = (event: any) => {
        const { value } = event;
        dispatch(setPageSize(Number(value)));
        // let SearchParamsValues = { page: 1, pageSize: value, start: 0, Order: columnIndex, OrderDir: direction, search: " ", StartDate: `${moment(startDate).format('MM-DD-YYYY')}`, EndDate: `${moment(endDate).format('MM-DD-YYYY')}`, ActionStatus: optionActionStatusValue, QBEvent: optionQBEventValue };
        let SearchParamsValues = { page: 1, pageSize: value, start: 0, Order: columnIndex, OrderDir: direction, search: " ", StartDate: startDate, EndDate: endDate, ActionStatus: optionActionStatusValue, QBEvent: optionQBEventValue };
        dispatch(getDataQuicksBookLogAsync(SearchParamsValues));
    }

    const handlePageChange = (pageNumber: any) => {
        const start = (pageNumber - 1) * pageSize;
        // let SearchParamsValues = { page: pageNumber, pageSize: pageSize, start: start, Order: columnIndex, OrderDir: direction, search: " ", StartDate: `${moment(startDate).format('MM-DD-YYYY')}`, EndDate: `${moment(endDate).format('MM-DD-YYYY')}`, ActionStatus: optionActionStatusValue, QBEvent: optionQBEventValue };
        let SearchParamsValues = { page: pageNumber, pageSize: pageSize, start: start, Order: columnIndex, OrderDir: direction, search: " ", StartDate: startDate, EndDate: endDate, ActionStatus: optionActionStatusValue, QBEvent: optionQBEventValue };
        dispatch(getDataQuicksBookLogAsync(SearchParamsValues));
    }

    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white">
                    <h3 className="card-title fw-bold headerTitle"  >{t('QuickBooks Log Reports')}</h3>
                    <div className="card-toolbar align-items-center">
                        {(quikBookLogList.length > 0) ? (
                            <div className='h-35px w-1px mx-1'></div>
                        ) : null}
                        {(quikBookLogList.length > 0) ? (
                            <div className="d-flex align-items-center">
                                <PageSizeSelect onChange={handlePageSizeChange} />
                            </div>
                        ) : null}
                        {(quikBookLogList.length > 0) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ) : null}
                        <div>
                            {(quikBookLogList.length > 0) ? (
                                <CustomPagination
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(currentPage - 1) * pageSize}
                                    t={t}
                                    recordsFiltered={recordsFiltered}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <a id="kt_OffCanvas"
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content={t("Filters")}
                            data-tooltip-place="bottom">
                            <i className="bi bi-filter fs-3 iconColor"></i>
                        </a>
                    </div>
                </div>
                <div className="card-body" >
                    <div className="table-responsive">
                        <QuickBookLogItem quikBookLogList={quikBookLogList} t={t} IsEdit={IsEdit} />
                    </div>
                </div>
            </div>
            <OffCanvas obj={generalObject} />
        </>
    )
}
export default QuickBookLog;